<template>
  <q-avatar :size="size" :class="['store-logo-container', customClass]">
    <q-img
      :src="logoUrl || '/images/placeholder.png'"
      contain
      @error="handleImageError"
    />
  </q-avatar>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  logoUrl: String,
  size: {
    type: String,
    default: '48px'
  },
  customClass: {
    type: String,
    default: ''
  }
});

function handleImageError(evt) {
  evt.target.src = '/images/placeholder.png';
  evt.target.onerror = null;
  evt.target.classList.add('fallback-image');
}
</script>
